import * as React from 'react';
import ComponentBasic from 'kts-scaffold-framework/component/ComponentBasic';
import ChatItemBasisProps from '../ChatItemBasisProps';
import ChatItemBasisState from '../ChatItemBasisState';
import ChatItemBasis from '../ChatItemBasis';

const css = require('./index.scss');

interface IProps extends ChatItemBasisProps {
    /** 聊天内容 */
    text: string;
}

/** 聊天文本项 */
export default class ChatItemText extends ChatItemBasis<IProps, ChatItemBasisState> {

    /** 子类渲染 */
    get childElement(): JSX.Element | string {
        return <p className={`${css['chat-item-text']}`} >{this.props.text}</p>;
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/ChatPanel/chatItem/ChatItemText/index.tsx